var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-chat-window",
      class: { opened: _vm.isOpen, closed: !_vm.isOpen }
    },
    [
      _c(
        "Header",
        {
          attrs: {
            showCloseButton: _vm.showCloseButton,
            title: _vm.title,
            imageUrl: _vm.titleImageUrl,
            onClose: _vm.onClose,
            colors: _vm.colors,
            disableUserListToggle: _vm.disableUserListToggle
          },
          on: { importrList: _vm.handleUserListToggle }
        },
        [[_vm._t("header")]],
        2
      ),
      _vm._v(" "),
      _vm.showUserList
        ? _c("UserList", { attrs: { participants: _vm.participants } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showUserList
        ? _c("MessageList", {
            attrs: {
              messages: _vm.messages,
              participants: _vm.participants,
              showTypingIndicator: _vm.showTypingIndicator,
              colors: _vm.colors,
              alwaysScrollToBottom: _vm.alwaysScrollToBottom,
              messageStyling: _vm.messageStyling
            },
            on: {
              scrollToTop: function($event) {
                return _vm.$emit("scrollToTop")
              },
              remove: function($event) {
                return _vm.$emit("remove", $event)
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "user-avatar",
                  fn: function(scopedProps) {
                    return [
                      _vm._t("user-avatar", null, {
                        user: scopedProps.user,
                        message: scopedProps.message
                      })
                    ]
                  }
                },
                {
                  key: "text-message-body",
                  fn: function(scopedProps) {
                    return [
                      _vm._t("text-message-body", null, {
                        message: scopedProps.message,
                        messageText: scopedProps.messageText,
                        messageColors: scopedProps.messageColors,
                        me: scopedProps.me
                      })
                    ]
                  }
                },
                {
                  key: "system-message-body",
                  fn: function(scopedProps) {
                    return [
                      _vm._t("system-message-body", null, {
                        message: scopedProps.message
                      })
                    ]
                  }
                },
                {
                  key: "text-message-toolbox",
                  fn: function(scopedProps) {
                    return [
                      _vm._t("text-message-toolbox", null, {
                        message: scopedProps.message,
                        me: scopedProps.me
                      })
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showUserList
        ? _c("UserInput", {
            attrs: {
              showEmoji: _vm.showEmoji,
              onSubmit: _vm.onUserInputSubmit,
              suggestions: _vm.getSuggestions(),
              showFile: _vm.showFile,
              placeholder: _vm.placeholder,
              colors: _vm.colors
            },
            on: {
              onType: function($event) {
                return _vm.$emit("onType")
              },
              edit: function($event) {
                return _vm.$emit("edit", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a3abaf2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a3abaf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-beautiful-chat/src/ChatWindow.vue
// module id = 1979
// module chunks = 116